// UI labels: `useLoyaltyFilterLabels` (see `src/client/components/Search/AGENTS.md`).

export const LOYALTY_SEARCH_FILTER_PARAM = 'loyalty'
export const LOYALTY_STAY_UPGRADE_SEARCH_FILTER_VALUE = 'Free Room Upgrade'
export const LOYALTY_SEARCH_FILTER_VALUES = [LOYALTY_STAY_UPGRADE_SEARCH_FILTER_VALUE]
